import { AnnouncementApiCalls } from "../../services/announcements";
import { mutation } from "./mutations";

const handleError = (err) => {
  console.log("Error in Login action : ", err);
};

export const getWorksheet = (batchID) => async (dispatch) => {
  try {
    const result = await AnnouncementApiCalls.getWorksheetForBatch(batchID);
    dispatch(mutation.setWorksheetList(result));
    let data = result.data.reverse();
    console.log("result 2 >", data);
    return data;
  } catch (err) {
    handleError(err);
  }
};
